import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import widgetService from 'live/services/widgets'
import { reducer } from './reducer'
import GMaps from './GMaps'
import Config from './components/Config/Config'
import init from './init'

export default widgetService.register({
    type: 'gmaps',
    get name() {
        return 'GMaps'
    },
    get description() {
        return ''
    },
    config: {
        key: 'digite a chave',
        steps: 5,
        zoom: 15,
        view: '',
        perspectives: [],
        btnFilters: [], // RETROCOMPATIBILIDADE
        btnFiltersOR: undefined,
        btnFiltersAND: [],
        maxSpeed: 120,
        extensionQualifier: '',
        positionsReportId: 116,
        tripsReportId: 0
    },
    //@ts-ignore
    ui: { configForm: Config },
    policies: { handleOwnMissingData: true },
    // the wrapper is needed to enable the reducer mechanism and comply the API
    impl: reactWidgetWrapper<GMapsState, GMapsMessage>(GMaps, reducer)
})

document.addEventListener('DOMContentLoaded', () => {
    init()
})
